import { getEmptyParagraphNode } from '@doltech/utils/lib/editor';
import { isNil, range } from 'lodash';
import { nanoid } from 'nanoid';

const ELEMENT_ALIGN_LEFT = 'align_left';
const ELEMENT_ALIGN_CENTER = 'align_center';
const ELEMENT_ALIGN_RIGHT = 'align_right';

export const tableDatav1ToV2 = (editorValue) => {
  // migrate the merge structure from old table to new table
  const tableNode = { ...editorValue[0] };
  // invalid structure
  if (tableNode?.type !== 'table') return editorValue;

  const columnCount = tableNode?.cellsWidth?.length || 0;
  const rowCount = tableNode?.children?.length || 0;

  // const cellsWithSpan = [];

  tableNode.children = range(rowCount).map((rowIndex) => {
    const rowNode = { ...tableNode.children[rowIndex] };
    rowNode.children = range(columnCount).map((colIndex) => {
      const cellNode = rowNode?.children?.[colIndex];

      // missing node case => insert cell => make sure our table row always have same columns
      if (!cellNode) {
        return {
          id: nanoid(),
          type: 'td',
          children: [
            {
              type: 'align_left',
              children: [getEmptyParagraphNode()],
            },
          ],
        };
      }

      // saving cell with span data to hide other cells
      // if (cellNode?.colSpan > 1 || cellNode?.rowSpan > 1) {
      //   cellsWithSpan.push({
      //     cellNode,
      //     rowIndex,
      //     colIndex,
      //   });
      // }

      if (!cellNode?.id) {
        cellNode.id = nanoid();
      }

      if (cellNode?.coordinate || cellNode?.selectToMerge) {
        // reset all
        cellNode.rowSpan = 1;
        cellNode.colSpan = 1;
      }

      // make sure cell children if align node
      if (
        ![ELEMENT_ALIGN_CENTER, ELEMENT_ALIGN_LEFT, ELEMENT_ALIGN_RIGHT].includes(cellNode?.type) &&
        cellNode.children &&
        ![ELEMENT_ALIGN_CENTER, ELEMENT_ALIGN_LEFT, ELEMENT_ALIGN_RIGHT].includes(
          cellNode?.children?.[0]?.type
        )
      ) {
        // if not align node => wrap it with align node (align_left as default value)
        cellNode.children = [
          {
            type: 'align_left',
            children: [
              {
                type: 'p',
                children: cellNode.children,
              },
            ],
          },
        ];
      }

      delete cellNode.coordinate;
      delete cellNode.selectToMerge;
      delete cellNode.hideTopControl;
      delete cellNode.active;
      delete cellNode.action;

      return cellNode;
    });

    return {
      ...rowNode,
      type: rowNode?.type || 'tr',
      id: rowNode?.id || nanoid(),
      isExpandable: rowNode?.isExpandable || false,
      isCollapsed: rowNode?.isCollapsed || false,
    };
  });

  if (isNil(tableNode.border)) {
    tableNode.border = true;
  }

  // now sync our column span by hiding other column
  // syncCellSpan({ cellsWithSpan, tableNode });
  // syncCellSpan({ cellsWithSpan, tableNode }); // recall to double check

  const result = [...editorValue];

  // remove invalid value
  tableNode.children = tableNode.children.filter((rowNode) => {
    return rowNode?.type;
  });

  // migrate cell widths => remove px
  tableNode.cellsWidth = (tableNode?.cellsWidth || [213, 213]).map((cellWidth) => {
    if (typeof cellWidth === 'string') {
      return Number(cellWidth.replace('px', '')) || 213;
    }
    return cellWidth;
  });

  result[0] = tableNode;
  return result;
};
